export const carouselScopeEvents = {
    init: 'init',
    onGotoStart: 'onGotoStart',
    onGotoFinish: 'onGotoFinish',
};
